import styled from 'styled-components'
import RatingItem from './RatingItem'
import { Fragment } from 'react'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 12px;
  background: #fff;
  border: 1px solid #e7e7ea;
  border-radius: 8px;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e7e7ea;
`

const ProductRating = ({ product }) => {
  const ratings = product?.appellationRatings ?? []

  if (ratings.length === 0) {
    return null
  }

  return (
    <Wrapper>
      {ratings.map((rating, index) => (
        <Fragment key={index}>
          {index > 0 && <Divider />}
          <RatingItem rating={rating} product={product} />
        </Fragment>
      ))}
    </Wrapper>
  )
}

export default ProductRating
